import React from 'react';

import type { MarketGroupType } from '@swf/sports/types/marketGroups';

import BetBuilderTab from '../BetBuilderTab/BetBuilderTab';

interface Props {
  type: MarketGroupType;
  isActive: () => boolean;
  name: string;
}

const TabContent: React.FC<Props> = ({ type, name, isActive }) => {
  switch (type) {
    case 'BET_BUILDER':
      return <BetBuilderTab name={name} isActive={isActive()} />;
    default:
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <>{name}</>;
  }
};

export default TabContent;
